<template>
  <li class="draggable" :class="{ disabled: stop.complete || !deliveryRun.editable }">
    <button type="button" class="btn btn-drag" :disabled="stop.complete || !deliveryRun.editable">
      <font-awesome :icon="['far', 'grip-lines']"/>
    </button>
    <div class="row">
      <div class="col-xs-1 text-center text-muted strong">{{ stop.order }}</div>
      <div class="col-xs-5">
        {{ stop.station.name }}
        <p class="small strong" v-if="stop.linked_station"><font-awesome :icon="['fas', 'link']" /> {{ stop.linked_station }}</p>
        <p class="small strong" v-if="stop.courier && stop.requested_by"><font-awesome :icon="['fas', 'user']" /> {{ stop.requested_by }}</p>
      </div>
      <div class="col-xs-2">{{ stop.pickup | nullable }}</div>
      <div class="col-xs-2">{{ stop.dropoff }}</div>
      <div class="col-xs-4 text-right">
        <template v-if="stop.complete">
          <span class="status status-success">Complete</span>
          <small class="d-block small">{{ stop.completed_at | date({ format: "DD/MM/YYYY [at] h:mma", utc: false }) }}</small>
        </template>
        <span class="status status-warning" v-else>Incomplete</span>
      </div>
    </div>
    <!-- /.row -->
  </li>
</template>

<script>
import { call, get } from 'vuex-pathify'
import swal from 'sweetalert'

export default {
  components: {
  },

  props: {
    stop: Object
  },

  computed: {
    ...get('deliveryRuns', ['deliveryRun']),

    hasConsignmentNote () {
      return this.stop.consignment_note !== null
    }
  },

  methods: {
    ...call('deliveryRuns', ['deleteDeliveryRunStop']),

    async confirmBeforeDeletingStop () {
      if (
        !await swal({
          text: 'Are you sure you want to delete this stop from the delivery run?',
          dangerMode: true,
          buttons: ['Cancel', 'Delete']
        })
      ) {
        return
      }

      const response = await this.deleteDeliveryRunStop({
        id: this.deliveryRun.id,
        stop: this.stop
      })

      this.$emit('deleted', response.data.data)
    },

    handleAddConsignmentNote () {
      this.$emit('addConsignmentNote', this.stop)
    }
  }
}
</script>

<style>
  .memo {
    right: 55px !important;
    color: #d9534f
  }
  .consignment-note {
    color: #16a085
  }
</style>
